module.exports = __webpack_public_path__ + "static/media/non_member_favorite_03.a298235f.jpg";